var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFbShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 18,
    viewBox: "0 0 11 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_304_16455)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.74922 10.5223V18H6.73672V10.5223H9.71016L10.3289 7.08398H6.73672V5.86758C6.73672 4.05 7.43453 3.35391 9.23578 3.35391C9.79609 3.35391 10.2464 3.36797 10.5077 3.39609V0.277734C10.0161 0.140625 8.81297 0 8.11859 0C4.44391 0 2.74922 1.77539 2.74922 5.60391V7.08398H0.480469V10.5223H2.74922Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_304_16455"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbShare);
export default __webpack_public_path__ + "static/media/fb_share.4fde75baf28f6826b3bf7b01bbde02e0.svg";
export { ForwardRef as ReactComponent };